import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { badgeColorVariants } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

const iconBadgeVariants = cva("flex items-center justify-center overflow-hidden rounded-md border", {
  variants: {
    size: {
      base: "h-6 w-6",
      large: "h-7 w-7",
    },
  },
  defaultVariants: {
    size: "base",
  },
})

export type IconBadgeProps = React.HTMLAttributes<HTMLSpanElement> &
  VariantProps<typeof badgeColorVariants> &
  VariantProps<typeof iconBadgeVariants> & {
    asChild?: boolean
  }

const IconBadge = React.forwardRef<HTMLSpanElement, IconBadgeProps>(
  ({ className, color, size, asChild = false, children, ...props }, ref) => {
    const Component = asChild ? Slot : "span"
    return (
      <Component
        ref={ref}
        className={cn(badgeColorVariants({ color }), iconBadgeVariants({ size }), className)}
        {...props}
      >
        {children}
      </Component>
    )
  }
)
IconBadge.displayName = "IconBadge"

export { IconBadge }
